export default "__VITE_ASSET__bAMX6_wD__"